//import * as React from "react";

import { CssBaseline } from '@mui/material';
import { useRoutes } from 'react-router-dom';
import { MatxTheme } from './components';
import { AuthProvider } from './contexts/JWTAuthContext';
import { SettingsProvider } from './contexts/SettingsContext';
//import routes from './routes';
import GenRoutes from './routes';
import '../fake-db';
import {
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query'
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'

import React, { useState, useEffect, useContext } from "react"
import axios from 'axios'
import { hubsupportalApi, apiUrl, refreshToken } from 'app/utils/utils';
import { useCookieState } from "use-cookie-state";

import { fetchPatientByUid, fetchPatientData } from 'app/components/Patient.jsx';
import {
  LS_ENV_KEY,
  LS_PATIENT_SELECTION_KEY,
  safeJsonParse,
  getPatientUidFromAny,
} from 'app/utils/persistedSelection';

import { SnackbarProvider, useSnackbar } from 'notistack';

import LongRequestNotifier from 'app/components/LongRequestNotifier';

import useWebSocket, { ReadyState } from 'react-use-websocket';
import { wsUrl, formatTime2 } from 'app/utils/utils';


const queryClient = new QueryClient()
export const HubIdContext = React.createContext({
  hubId: "",
  setHubId: () => { },

  hubList: {},
  setHubList: () => { },

  currentHubSelectionMethod: "",
  setCurrentHubSelectionMethod: () => { },

  patient: {},
  setPatient:  () => { },

  sendMessage: () => {},
  lastMessage: "",
  readyState: ReadyState.UNINSTANTIATED
});

// (persistedSelection helpers imported)

const App = () => {

// Custom hook to manage WebSocket connection
const useWebSocketConnection = () => {
  let socketUrl = wsUrl() + "action";
  const { sendMessage, lastMessage, readyState } = useWebSocket(socketUrl, {
    onOpen: () => console.log('WebSocket opened'),
    shouldReconnect: (closeEvent) => true,
    reconnectInterval: 3000,
    reconnectAttempts: Infinity,
  });

  return { sendMessage, lastMessage, readyState };
};
const { sendMessage, lastMessage, readyState } = useWebSocketConnection();

  React.useEffect(() => {
    function login_check() {
      (async () => {
        try {
          const response = await hubsupportalApi.get("login_check"); //send API call to authenticate
        } catch (e) {
          console.log(e);
        }
      })();
    }
    const timer = setInterval(login_check, 5 * 60 * 1000);
    return () => {
      clearInterval(timer);
    };
  }, []);

  React.useEffect(() => {
    function auto_token_refresh() {
      (async () => {
        try {
          const resp = await refreshToken();
          localStorage.setItem("access_token", resp.access_token);
          localStorage.setItem("refresh_token", resp.refresh_token);
        } catch (e) {
          console.log(e);
        }
      })();
    }
    const timer = setInterval(auto_token_refresh, 25 * 1000);
    return () => {
      clearInterval(timer);
    };
  }, []);

  //const content = useRoutes(routes);
  const [actions, setActions] = useState({});
  const [reports, setReports] = useState({});


  const [hubId, setHubId] = useCookieState("hubid", "LM8HA1");
  const [hubList, setHubList] = useCookieState("hubList", {});
  const [currentHubSelectionMethod, setCurrentHubSelectionMethod] = useCookieState("currentHubSelectionMethod", "single");

  // Store patient in context; on refresh we hydrate it from localStorage.
  const [patient, _setPatient] = useState({});

  const setPatient = (next) => {
    _setPatient(next);

    // Persist a minimal selection so we can restore after a hard refresh.
    try {
      const uid = getPatientUidFromAny(next);
      if (!uid) {
        window.localStorage.removeItem(LS_PATIENT_SELECTION_KEY);
        return;
      }

      const env = (next?.environment || window.localStorage.getItem(LS_ENV_KEY) || 'prod').toString();
      const payload = {
        patient_uid: uid,
        environment: env,
        saved_at: new Date().toISOString(),
      };
      window.localStorage.setItem(LS_PATIENT_SELECTION_KEY, JSON.stringify(payload));
    } catch (_e) {
      // ignore persistence errors (private browsing, disabled storage, etc.)
    }
  };

 
  const hubIdContext = { 
    hubId, setHubId, 
    hubList, setHubList, 
    currentHubSelectionMethod, setCurrentHubSelectionMethod, 
    patient, setPatient,
    sendMessage, lastMessage, readyState 
  };
  console.log(hubIdContext);

  if (typeof hubList == "string") {
    try {
      setHubList(JSON.parse(hubList));
    } catch (e) {
      console.log(e);
    }
  }


  useEffect(() => {
    (async () => {
      try {
        const response = await hubsupportalApi.get("hs_action", { cache_timeout: 3600 });

        //console.log("AuthNavigations","hs_action", response);
        //console.log("AuthNavigations","hs_action.data", response.data);
        //console.log("AuthNavigations","hs_action.data.data", response.data.data);

        setActions(response.data.data);

      } catch (err) {
        console.error(err);
      }
    })();
  }, []);

  // Hydrate selected patient on refresh.
  useEffect(() => {
    // Do not override an already-selected patient (e.g. if something sets it very early).
    const existingUid = getPatientUidFromAny(patient);
    if (existingUid) return;

    let saved = null;
    try {
      saved = safeJsonParse(window.localStorage.getItem(LS_PATIENT_SELECTION_KEY));
    } catch (_e) {
      saved = null;
    }
    const savedUid = (saved?.patient_uid || '').toString().trim();
    if (!savedUid) return;
    const savedEnv = (saved?.environment || window.localStorage.getItem(LS_ENV_KEY) || 'prod').toString();

    (async () => {
      try {
        const base = await fetchPatientByUid(savedUid, savedEnv);
        if (!base) return;
        const full = await fetchPatientData(base, savedEnv);
        if (!full) return;
        setPatient(full);
      } catch (e) {
        console.error('Failed to hydrate patient selection from localStorage', e);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    (async () => {
      try {
        const response = await hubsupportalApi.get("hs_report", { cache_timeout: 3600 });

        console.log("AuthNavigations","hs_report", response);
        console.log("AuthNavigations","hs_report.data", response.data);
        console.log("AuthNavigations","hs_report.data.data", response.data.data);

        setReports(response.data.data);

      } catch (err) {
        console.error(err);
      }
    })();
  }, []);
  const content = useRoutes(GenRoutes(actions,reports));


  const search = window.location.search;
  const params = new URLSearchParams(search);
  const foo = params.get('hubId');
  console.log("queryParm", foo)
  if (foo && (foo != hubId || currentHubSelectionMethod != "single")) {
    setHubId(foo);
    setCurrentHubSelectionMethod("single");
  }

  return (

    <SettingsProvider>
      <AuthProvider>
        <HubIdContext.Provider value={hubIdContext}>
          <MatxTheme>
            <SnackbarProvider maxSnack={3}>
              <LongRequestNotifier />
              <CssBaseline />
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <QueryClientProvider client={queryClient} >
                  {content}
                </QueryClientProvider>
              </LocalizationProvider>
            </SnackbarProvider>
          </MatxTheme>
        </HubIdContext.Provider>
      </AuthProvider>
    </SettingsProvider>

  );
};

export default App;
